import { h } from "@stencil/core";
import { getActualLanguageWithoutAlias, parseCodeToHAST, registerLanguage } from "@genexus/markdown-parser/dist/parse-code.js";
import { LAST_NESTED_CHILD_CLASS } from "./markdown-to-jsx";
let lastNestedChild;
const checkAndGetLastNestedChildClass = (element) => element === lastNestedChild ? LAST_NESTED_CHILD_CLASS : undefined;
const codeToJSXDictionary = {
    element: (element) => {
        const className = element.properties.className;
        const lastNestedChildClass = checkAndGetLastNestedChildClass(element);
        const highlightJSClasses = className ? className.join(" ") : undefined;
        return (h("span", { class: {
                [highlightJSClasses]: !!highlightJSClasses,
                [lastNestedChildClass]: !!lastNestedChildClass
            } }, renderCodeChildren(element)));
    },
    text: (element) => element.value
};
function renderCodeChildren(element) {
    return element.children.map(child => codeToJSXDictionary[child.type](child));
}
const findLastNestedChild = (elementWithChildren) => {
    const lastChild = elementWithChildren.children.at(-1);
    // The last element have children. We must check its sub children
    if (lastChild.children?.length > 0) {
        return findLastNestedChild(lastChild);
    }
    return elementWithChildren;
};
export const parseCodeToJSX = async (code, language, renderCode, isLastNestedChild) => {
    const actualLanguage = getActualLanguageWithoutAlias(language || "plaintext");
    // Register the language
    await registerLanguage(actualLanguage);
    const tree = parseCodeToHAST(actualLanguage, code);
    lastNestedChild = undefined; // Reset last nested child
    // Find last nested child
    if (isLastNestedChild) {
        lastNestedChild = findLastNestedChild(tree);
    }
    const nestedChildIsCodeTag = isLastNestedChild && tree === lastNestedChild;
    return renderCode({
        language: language || "plaintext",
        nestedChildIsCodeTag: nestedChildIsCodeTag,
        plainText: code,
        renderedContent: tree.children.map(child => codeToJSXDictionary[child.type](child))
    });
};
/**
 * @deprecated Use the `ch-code` component to render code blocks
 */
export const defaultCodeRender = (options) => (h("pre", null, h("code", { class: {
        [`hljs language-${options.language}`]: true,
        [LAST_NESTED_CHILD_CLASS]: options.nestedChildIsCodeTag
    } }, h("div", { class: "code-block__content" }, options.renderedContent))));
